import React from "react";

import type { RecordType } from "@datadog/browser-rum/internal";
import type { TableRowSelection } from "antd/es/table/interface";
import type { TableProps as RcTableProps } from "rc-table/lib/Table";

export type GridProps = {
    additionalFilters?: any[];
    className?: string;
    columns: any[];
    columnsData: any[];
    /**
     * @deprecated We no longer want to use the AndD Grid System and Row for the header.
     * We are going to use just basic Flexible components and Define as many rows as we need.
     */
    header?: JSX.Element;
    /**
     * @todo rename to header once we remove all the old header implementations
     */
    flexibleHeader?: JSX.Element;
    footer?: JSX.Element | string;
    loading?: boolean;
    totalRecords?: number;
    pageWidth?: "standard" | "wide";
    rowSelection?: TableRowSelection<any>;
    tableSize?: "default" | "middle" | "small";
    defaultParams?: Partial<QueryParams>;
    rowClassName?: any;
    rowKey?: any;
    onRow?: any;
    filterOperators?: Record<string, OperatorType>;
    draggable?: boolean;
    pagination?: boolean;
    pageSizeOptions?: Array<string>;
    onSortData?: (newColumnsData: any[]) => void;
    scroll?: RcTableProps<RecordType>["scroll"] & {
        scrollToFirstRowOnChange?: boolean;
    };
    useQueryParamsUrl?: boolean;
    infiniteScroll?: boolean;
    getMoreRows?: () => any;
    headerSpacing?: "small" | "medium";
    gutter?: [number, number];
    "data-testid"?: string;
    customEmpty?: React.ReactNode;
};

// ENUM CLEAN UP
// eslint-disable-next-line no-restricted-syntax
export enum OperatorType {
    CONTAINS = "contains",
    IS = "is",
    IN = "in",
    OVERLAPS = "overlaps",
    STARTS_WITH = "starts_with",
    IN_JSON_ARRAY = "in_json_array",
}

export interface SortParams {
    key: string;
    value: string | number | boolean | any[];
}

export interface FilterParams<T = string | boolean | number | any[] | null> {
    operator?: OperatorType;
    key: string;
    value: T | T[] | null;
}

export interface QueryParams<T = string | boolean | number | any[] | null> {
    orderBy: Array<SortParams> | null;
    filterBy: Array<FilterParams<T>> | null;
    page: number;
    pageSize: number;
    profileId?: string;
}

export const queryParamsProps = ["orderBy", "filterBy", "page", "pageSize"];

export const filterkeySearch = "search";

export type PaginationResponse<T> = {
    page: number;
    pageSize: number;
    total: number;
    hasMore?: boolean;
    items: Array<T>;
};
